// @flow
import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
const PREFIX = 'App.ViewProperty.AffordableSetup.WaitlistV2.EnablementModals';

const messages = defineMessages({
  enableTitle: {
    id: `${PREFIX}.Enable.Title`,
    defaultMessage: 'Enable Affordable Waitlist',
  },
  enableIntro: {
    id: `${PREFIX}.Enable.Intro`,
    defaultMessage:
      'Enabling Affordable Waitlist will migrate your existing affordable applications to the new waitlist when you save your configuration.',
  },
  enableTableIntro: {
    id: `${PREFIX}.Enable.TableIntro`,
    defaultMessage: 'The following applications will be migrated:',
  },
  statusHeader: {
    id: `${PREFIX}.Enable.StatusHeader`,
    defaultMessage: 'Application status',
  },
  countHeader: {
    id: `${PREFIX}.Enable.CountHeader`,
    defaultMessage: 'Count',
  },
  statusWaiting: {
    id: `${PREFIX}.Enable.StatusWaiting`,
    defaultMessage: 'Waiting',
  },
  statusInProcess: {
    id: `${PREFIX}.Enable.StatusInProcess`,
    defaultMessage: 'In-Process',
  },
  statusCanceled: {
    id: `${PREFIX}.Enable.StatusCanceled`,
    defaultMessage: 'Canceled',
  },
  statusDenied: {
    id: `${PREFIX}.Enable.StatusDenied`,
    defaultMessage: 'Denied',
  },
  total: {
    id: `${PREFIX}.Enable.Total`,
    defaultMessage: 'Total',
  },
  enableFooter: {
    id: `${PREFIX}.Enable.Footer`,
    defaultMessage:
      'Applications missing required information will be flagged for review and can be updated after migration. Select Continue to finish configuring your waitlist, or Cancel to leave the waitlist disabled.',
  },
  enableNoneEligible: {
    id: `${PREFIX}.Enable.NoneEligible`,
    defaultMessage:
      'No existing applications are eligible for migration. You can continue configuring your waitlist.',
  },
  enableNoneFooter: {
    id: `${PREFIX}.Enable.NoneFooter`,
    defaultMessage:
      'Select Continue to finish configuring your waitlist, or Cancel to leave the waitlist disabled.',
  },
  continue: {
    id: `${PREFIX}.Enable.Continue`,
    defaultMessage: 'Continue',
  },
  gotIt: {
    id: `${PREFIX}.GotIt`,
    defaultMessage: 'Got it',
  },
  startedTitle: {
    id: `${PREFIX}.Started.Title`,
    defaultMessage: 'Affordable Waitlist enabled',
  },
  startedSaved: {
    id: `${PREFIX}.Started.Saved`,
    defaultMessage:
      'Your Affordable Waitlist configuration has been saved successfully.',
  },
  startedMigrating: {
    id: `${PREFIX}.Started.Migrating`,
    defaultMessage:
      'Fortress is migrating your existing affordable applications to the new waitlist in the background. Applications missing required information will be flagged so you can review and update them later.',
  },
  startedUsable: {
    id: `${PREFIX}.Started.Usable`,
    defaultMessage:
      'You can begin using Affordable Waitlist while the migration is running. A migration summary, including any exceptions requiring attention, will be emailed to you when the process completes.',
  },
  notStartedTitle: {
    id: `${PREFIX}.NotStarted.Title`,
    defaultMessage: 'Configuration saved, migration not started',
  },
  notStartedSaved: {
    id: `${PREFIX}.NotStarted.Saved`,
    defaultMessage:
      'Your Affordable Waitlist configuration has been saved, but the migration of your existing applications could not be started.',
  },
  notStartedUnchanged: {
    id: `${PREFIX}.NotStarted.Unchanged`,
    defaultMessage:
      'No applications have been changed. The migration status has been kept so it can be reviewed and retried. Contact support if the problem persists.',
  },
});

export default messages;
